import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-manga-list',
  standalone: true,
  templateUrl: './manga-list.component.html',
  styleUrls: ['./manga-list.component.css'],
  imports: [CommonModule] // IMPORTANTE: Agregar esto para que funcione *ngFor
})
export class MangaListComponent {
  @Input() mangas: any[] = [];
}

